import './styles/tokens.css';
import './styles/base.css';
import './styles/app.css';
import './styles/game.css';

import { createRouter } from './lib/router';
import { loadAndApplyPreferences } from './lib/session';
import { initSocialOverlay } from './lib/social-overlay';
import { renderHome } from './views/home';
import { renderPlayMenu } from './views/play-menu';
import { renderStopTheClockMenu } from './views/stop-the-clock-menu';
import { renderStackTowerMenu } from './views/stack-tower-menu';
import { renderPractice } from './views/practice';
import { renderChallenge10s } from './views/challenge-10s';
import { renderDailyChallenge } from './views/daily-challenge';
import { renderLocalDuel } from './views/local-duel';
import { renderOnlineDuel } from './views/online-duel';
import { renderRankedDuel } from './views/ranked-duel';
import { renderKnockout } from './views/knockout';
import { renderLeaderboard } from './views/leaderboard';
import { renderAccount } from './views/account';
import { renderStats } from './views/stats';
import { renderAchievements } from './views/achievements';
import { renderChallenges } from './views/challenges';
import { renderFriends } from './views/friends';
import { renderCustomise } from './views/customise';
import { renderStore } from './views/store';
import { renderInventory } from './views/inventory';
import { renderCurrencyStore } from './views/currency-store';
import { renderAdmin } from './views/admin';
import { renderForgotPassword } from './views/forgot-password';
import { renderResetPassword } from './views/reset-password';
import { renderVerifyEmail } from './views/verify-email';
import { renderStackTower, renderStackTower60 } from './views/stack-tower';
import { renderStackTowerOnline } from './views/stack-tower-online';
import { renderStackTowerRanked } from './views/stack-tower-ranked';

const app = document.querySelector<HTMLDivElement>('#app');
if (!app) throw new Error('Application mount element is missing');

const { navigate } = createRouter(
  app,
  {
    home: renderHome,
    play: renderPlayMenu,
    'play/stop-the-clock': renderStopTheClockMenu,
    'play/stack-tower': renderStackTowerMenu,
    'play/local': renderLocalDuel,
    'play/online': renderOnlineDuel,
    'play/ranked': renderRankedDuel,
    'play/knockout': renderKnockout,
    leaderboard: renderLeaderboard,
    practice: renderPractice,
    'challenge-10s': renderChallenge10s,
    'daily-challenge': renderDailyChallenge,
    account: renderAccount,
    stats: renderStats,
    achievements: renderAchievements,
    challenges: renderChallenges,
    friends: renderFriends,
    customise: renderCustomise,
    store: renderStore,
    inventory: renderInventory,
    'currency-store': renderCurrencyStore,
    admin: renderAdmin,
    'forgot-password': renderForgotPassword,
    'reset-password': renderResetPassword,
    'verify-email': renderVerifyEmail,
    'stack-tower': renderStackTower,
    'stack-tower-60': renderStackTower60,
    'stack-tower-online': renderStackTowerOnline,
    'stack-tower-ranked': renderStackTowerRanked,
  },
  'home',
);

// Apply the signed-in player's saved accessibility preferences as early as
// possible, so a returning player's settings take effect without waiting for
// them to visit the account page. No-op (defaults) when signed out.
void loadAndApplyPreferences();

// Mounted once, outside the router's own container, so it survives every
// page navigation (see social-overlay.ts for why that matters).
initSocialOverlay(navigate);
